module.exports = __webpack_public_path__ + "static/media/logo_header.e5c71ed6.png";